import { render } from "./BLS.vue?vue&type=template&id=e9a996e2"
import script from "./BLS.vue?vue&type=script&lang=js"
export * from "./BLS.vue?vue&type=script&lang=js"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__